import { useEffect, useRef, useState } from "react";
import { getAssetUrl } from "@/utils/common";
import { useStore } from "@/store";
import { PageMode } from "@/store/types";
import styles from './index.module.scss';
import { useTransition, animated } from "@react-spring/web";

const TransitioningVideo = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const mode = useStore((state) => state.mode);
  const prevModeRef = useRef<PageMode>(mode);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // console.log('mode',mode,prevModeRef.current);
    if (prevModeRef.current === PageMode.SILENT && mode !== PageMode.SILENT) {
      setIsVisible(true);
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        // videoRef.current.playbackRate = 2;
        videoRef.current.play();
      }
    }else {
      setIsVisible(false);
    }
    prevModeRef.current = mode;
  }, [mode]);

  // console.log('isVisible',isVisible,mode,prevModeRef.current);
  

  const handleVideoEnd = () => {
    setIsVisible(false);
  };


  const transitions = useTransition(isVisible, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: 500
    }
  });

  return transitions((style, show) => 
    show && (
      <animated.div style={style} className={styles.video}>
        <video 
          className={styles.video} 
          ref={videoRef} 
          src={getAssetUrl('videos/silent/transition.mp4')} 
          autoPlay 
          muted 
          onEnded={handleVideoEnd}
        />
      </animated.div>
    )
  );
}

export default TransitioningVideo;